// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {Fragment, useState} from 'react';
import {Editor} from '../../../shared/editor/editor';
import {Button} from '../../../shared/button';
import {Accordion} from '../ui/accordion/accordion';
import styles from './bounty_bug_reporting.module.less';

export interface i_bounty_reporting_item {
  title: string;
  description?: string;
  default_open?: boolean;
}

export interface i_bounty_bug_reporting_props {
  title?: string;
  description?: string;
  items?: i_bounty_reporting_item[];
}

export const Bounty_bug_reporting = ({
  title,
  description,
  items=[],
}: i_bounty_bug_reporting_props)=>{
  const accordion_items = items.map((item, index)=>({
    key: `${item.title}-${index}`,
    title: item.title,
    content: item.description,
    default_open: item.default_open,
    icon: <span className={styles.bounty_bug_reporting__number}>
      {index+1}
    </span>,
  }));
  return <section className={styles.bounty_bug_reporting}>
    <div className={styles.bounty_bug_reporting__inner}>
      <div className={styles.bounty_bug_reporting__heading}>
        {title&&<h3 className={styles.bounty_bug_reporting__title}>
          {title}
        </h3>}
        {description&&<p
          className={styles.bounty_bug_reporting__description}>
          {description}
        </p>}
      </div>
      {!!items.length&&<Accordion
        items={accordion_items}
        cls={styles.bounty_bug_reporting__list}
        marker={<span className={styles.bounty_bug_reporting__chevron}/>}
        classes={{
          item: styles.bounty_bug_reporting__item,
          trigger: styles.bounty_bug_reporting__trigger,
          title: styles.bounty_bug_reporting__item_title,
          content: styles.bounty_bug_reporting__content,
        }}
      />}
    </div>
  </section>;
};

interface i_bounty_bug_reporting_editor_props {
  value: i_bounty_bug_reporting_props;
  on_change: (value: i_bounty_bug_reporting_props)=>void;
  on_cancel?: ()=>void;
}

export const Bounty_bug_reporting_editor = (
  props: i_bounty_bug_reporting_editor_props
)=>{
  const [state, set_state] = useState<i_bounty_bug_reporting_props>({
    ...props.value,
    items: props.value?.items||[],
  });

  const items = state.items||[];

  const update_item = (
    index: number,
    item: i_bounty_reporting_item
  )=>
  {
    const next_items = [...items];
    next_items[index] = item;
    set_state({...state, items: next_items});
  };

  const delete_item = (index: number)=>{
    set_state({
      ...state,
      items: items.filter((_, item_index)=>item_index!=index),
    });
  };
  return <Editor<i_bounty_bug_reporting_props>
    value={state}
    editors={[
      {key: 'title', label: 'Title', type: 'text'},
      {key: 'description', label: 'Description', type: 'textarea'},
    ]}
    on_change={set_state}
    on_save={()=>props.on_change(state)}
    on_cancel={props.on_cancel}>
    <Fragment>
      <h4>Reporting sections</h4>
      {items.map((item, index)=><div key={index}>
        <Editor<i_bounty_reporting_item>
          title={item.title||`Section ${index+1}`}
          value={item}
          editors={[
            {key: 'title', label: 'Title', type: 'text'},
            {
              key: 'description',
              label: 'Description',
              type: 'textarea',
            },
            {
              key: 'default_open',
              label: 'Open by default',
              type: 'boolean',
            },
          ]}
          on_change={(value: i_bounty_reporting_item)=>
            update_item(index, value)}
        />

        <Button
          caption="Delete section"
          size="xs"
          color="secondary"
          on_click={()=>delete_item(index)}
        />
        <hr/>
      </div>)}

      <Button
        caption="Add section"
        size="xs"
        on_click={()=>set_state({
          ...state,
          items: [
            ...items,
            {
              title: '',
              description: '',
              default_open: false,
            },
          ],
        })}
      />
    </Fragment>
  </Editor>;
};
